import { useLocation, useNavigate } from 'react-router';
import { textSizes } from '../../config/config';
import dynamicfunction from '../../utils/dynamicfunction';
import LoaderModal from '../LoaderModal';
import Text from '../Text';
import ViewReverse from '../ViewReverse';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { fontSizes } from '../../constants/constants';
import { getContentKeyAccToLang } from '../../utils/utils';

const navItems = [
  {
    label: 'personal_information',
    path: '/personal-information',
    sectionKey: 'PersonalInformation',
  },
  {
    label: 'contact_information',
    path: '/contact-information',
    sectionKey: 'ContactInformation',
  },
  {
    label: 'employer_information',
    path: '/employer-information',
    sectionKey: 'EmployerInformation',
  },
  {
    label: 'general_information',
    path: '/general-information',
    sectionKey: 'GeneralInformation',
  },
  {
    label: 'bank_custodian_information',
    path: '/bank-custodian-information',
    sectionKey: 'BankCustodianInformation',
  },
  {
    label: 'investment_portfolio',
    path: '/investment-portfolio',
    sectionKey: 'InvestmentPortfolio',
  },
  {
    label: 'client_classification',
    path: '/client-classification',
    sectionKey: 'ClientClassification',
  },
  // {
  //   label: 'special_cases',
  //   path: '/special-cases',
  //   sectionKey: 'SpecialCasesd',
  // },
  {
    label: 'tax_declaration',
    path: '/tax-declaration',
    sectionKey: 'TaxDeclaration',
  },
  {
    label: 'document_vault',
    path: '/document-vault',
    sectionKey: 'DocumentVault',
  },
  {
    label: 'submit_application',
    path: '/submit-application',
    sectionKey: 'SubmitApplication',
  },
];

const IndividualLayout = ({ children, step, setStep }) => {
  const navigate = useNavigate();
  const { isArabic, TextWeight } = dynamicfunction();
  const { individualContent } = useSelector((state) => state.content);
  const { applicantLoading } = useSelector((state) => state.individual);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(
      individualContent?.individual_account_opening?.data?.attributes,
      key,
      isArabic
    );
  };

  return (
    <>
      <div className='z-[1000]'>
        <div className='lg:w-[85%] 2xl:w-[1500px] lg:mx-auto py-[8px]'>
          <Text
            text={getContentKey(navItems[step]?.label || '')}
            size={fontSizes.h19}
            isTruncate={false}
            weight={TextWeight.bold}
          />

          <div
            className={`flex justify-center items-center gap-[5px] my-2 flex-1 ${isArabic ? 'flex-row-reverse' : 'flex-row'
              }`}
          >
            {navItems.map((item, index) => (
              <div
                key={index}
                className={`h-[4px] flex-1 cursor-pointer transition-colors duration-300 ${index <= step ? 'bg-primary' : 'bg-silver-text'
                  }`}
                onClick={
                  () => {
                    setStep(index);
                  }
                  // !corporate_post_loading &&
                  // navigate(item.path)
                }
              />
            ))}
          </div>

          {/* Step Counter */}
          <ViewReverse className='gap-2'>
            <Text
              text={getContentKey('step')}
              size={textSizes.h16}
              color={'text-primary'}
              isTruncate={false}
              weight={TextWeight.medium}
            />
            <Text
              text={`${String(step + 1).padStart(2, '0')}/${String(
                navItems?.length
              ).padStart(2, '0')}`}
              size={textSizes.h16}
              color={'text-primary'}
              isTruncate={false}
              weight={TextWeight.medium}
            />
          </ViewReverse>
        </div>
      </div>

      {/* Content Container */}
      <div className='mx-4 lg:w-[85%] 2xl:w-[1500px] lg:mx-auto p-8 shadow-md border border-border rounded-xl mb-6 mt-8'>
        {children}
      </div>

      <LoaderModal open={applicantLoading} />
    </>
  );
};

export default IndividualLayout;
